import Base, { wrapStorage } from './Base'

class Local extends Base {
  constructor(rootComponent) {
    super(window.localStorage, rootComponent)
  }
}

export const setAppInstance = (app) => {
  Local.instance = wrapStorage(new Local(app))
  window.persistence = {local: Local.instance}
}

export default Local



// WEBPACK FOOTER //
// ./src/Persistence/Local.js